module.exports = __webpack_public_path__ + "img/组 3@2x.4bfc3669.png";